import React from "react";
import logInInfo from "./images/login.png";
import signUpInfo from "./images/signupInfo.png";
import forgotInfo from "./images/forgetPass.png";
import newPasswordInfo from "./images/newPassInfo.png";
import logo from "../../../images/logo/white-ontrack-logo.jpeg";
import { useNavigate } from "react-router-dom";

const images = {
  login: logInInfo,
  signup: signUpInfo,
  forgot: forgotInfo,
  otp: forgotInfo,
  resend: forgotInfo,
  newpassword: newPasswordInfo,
};

const fallbackImage = forgotInfo;

const titles = {
  signup: "Unlock Your Dream Career",
  default: "Your Career Dashboard Awaits",
};

const descriptions = {
  signup:
    "Create your account to access personalized job matches, career insights, and tools to elevate your future.",
  default:
    "Explore tailored job recommendations, AI-driven insights, and resources to shape your future.",
};

const InfoPanel = ({ parent, children }) => {
  const imageSrc = images[parent] || fallbackImage;
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen w-full bg-white">
      {/* Main Content */}
      <div className="flex flex-col md:flex-row flex-grow">
        {/* Logo Header */}
        <div className="p-4">
          <img
            src={logo}
            alt="Ontrack Logo"
            className="w-28 h-auto cursor-pointer"
            onClick={() => navigate("/")}
          />
        </div>
        {/* Left Section - Children */}
        <div className="w-full md:w-1/2 flex items-center justify-center px-6 py-8 sm:p-10 md:p-12 lg:p-16 bg-white">
          {children}
        </div>

        {/* Right Section - Info Panel */}
        <div className="hidden md:flex w-1/2 bg-gradient-to-r from-purple-100 to-pink-100 items-center justify-center">
          <div className="max-w-md text-center px-4 py-8">
            <div className="flex justify-center mb-6">
              <img
                src={imageSrc}
                alt={`${parent || "default"} Info`}
                className="max-h-64 object-contain"
              />
            </div>
            <h2 className="text-2xl font-bold text-purple-800 mt-4">
              {titles[parent] || titles.default}
            </h2>
            <p className="text-gray-600 mb-6">
              {descriptions[parent] || descriptions.default}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPanel;
